import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import {FormsModule} from '@angular/forms';
import {HttpClientModule} from '@angular/common/http';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {ClipboardModule} from '@angular/cdk/clipboard';
import {ToolbarModule} from 'primeng/toolbar';
import {ProgressBarModule} from 'primeng/progressbar';
import {ButtonModule} from 'primeng/button';
import {CheckboxModule} from 'primeng/checkbox';
import {InputTextModule} from 'primeng/inputtext';
import {CardModule} from 'primeng/card';
import {ProgressSpinnerModule} from 'primeng/progressspinner';
import {DropdownModule} from 'primeng/dropdown';
import {DataViewModule} from 'primeng/dataview';
import {DialogModule} from 'primeng/dialog';
import {TooltipModule} from 'primeng/tooltip';
import {CookieService} from 'ngx-cookie-service';
import {ApiCallService} from './api-call.service';
import { AppComponent } from './app.component';

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpClientModule,
    BrowserAnimationsModule,
    ClipboardModule,
    ToolbarModule,
    ProgressBarModule,
    ButtonModule,
    CheckboxModule,
    InputTextModule,
    CardModule,
    ProgressSpinnerModule,
    DropdownModule,
    DataViewModule,
    DialogModule,
    TooltipModule
  ],
  providers: [CookieService, ApiCallService],
  bootstrap: [AppComponent]
})
export class AppModule { }
